var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drainage-link"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm.goWx}},[_vm._v(" 打开微信 ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-logo"},[_c('img',{attrs:{"src":require("@/static/images/wx-logo.png")}})])
}]

export { render, staticRenderFns }